import React from 'react';
import { Truck, Shirt, Zap, ShieldCheck, Users, Box, Scissors, Target } from 'lucide-react';
import medical from  "../../assets/medical.webp";
import polo from '../../assets/polo.webp';
import acid from '../../assets/acid.webp';
import oversize from '../../assets/Oversized.webp';
import linen from '../../assets/aboutapperale.webp';
import hoodies from '../../assets/hoodies.webp';
import bag from '../../assets/bags.webp';
import demin from '../../assets/denim.jpg';
import kids from '../../assets/kids.jpg';
import sleep from '../../assets/sleep.jpg';
import fabric from '../../assets/fabric.jpg';
import inner from '../../assets/inner.jpg';
import joggers from '../../assets/jogger.jpg';
const ApparelServices = ({ company }) => {
  const products = [
    {
      name: "Medical scrubs",
      category: "uniforms",
      details: "100% Organic Pima Cotton, 220 GSM",
      items: "T-shirts, Polos, Hoodies",
      img: (medical),
    },
    {
      name: "Polo T-shirts",
      category: "Athleisure",
      details: "Recycled Polyester, Moisture-wicking",
      items: "Leggings, Gym-wear, Windbreakers",
      img: (polo)
    },
     {
      name: "Joggers",
      category: "Knitwear",
      details: "100% Organic Pima Cotton, 220 GSM",
      items: "T-shirts, Polos, Hoodies",
      img: (joggers)
    },
    {
      name: "Aicd-wash T-shirts",
      category: "Athleisure",
      details: "Recycled Polyester, Moisture-wicking",
      items: "Leggings, Gym-wear, Windbreakers",
      img:(acid)
    },
    {
      name: "Oversized T-shirts",
      category: "Woven",
      details: "Easy-iron Twill, Wrinkle Resistant",
      items: "Formal Shirts, Chinos, Blazers",
      img: (oversize)
    },
     {
      name: "Linen Shirts and Trousers",
      category: "Knitwear",
      details: "100% Organic Pima Cotton, 220 GSM",
      items: "T-shirts, Polos, Hoodies",
      img: (linen)
    },
    {
      name: "Denim shirts and trousers",
      category: "Athleisure",
      details: "Recycled Polyester, Moisture-wicking",
      items: "Leggings, Gym-wear, Windbreakers",
      img: (demin)
    },
    {
      name: "Hoodies",
      category: "Woven",
      details: "Easy-iron Twill, Wrinkle Resistant",
      items: "Formal Shirts, Chinos, Blazers",
      img: (hoodies)
    },
     {
      name: "Tote bags",
      category: "Knitwear",
      details: "100% Organic Pima Cotton, 220 GSM",
      items: "T-shirts, Polos, Hoodies",
      img: (bag)
    },
    {
      name: "Kids Wear",
      category: "Athleisure",
      details: "Recycled Polyester, Moisture-wicking",
      items: "Leggings, Gym-wear, Windbreakers",
      img:(kids)
    },
    {
      name: "Sleep wear",
      category: "Woven",
      details: "Easy-iron Twill, Wrinkle Resistant",
      items: "Formal Shirts, Chinos, Blazers",
      img: (sleep)
    },
     {
      name: "Inner Wear and Lingarie",
      category: "Knitwear",
      details: "100% Organic Pima Cotton, 220 GSM",
      items: "T-shirts, Polos, Hoodies",
      img: (inner)
    },
    {
      name: "Bulk Fabric supplying",
      category: "Athleisure",
      details: "Recycled Polyester, Moisture-wicking",
      items: "Leggings, Gym-wear, Windbreakers",
      img: (fabric)
    },
  ];

  return (
    <div className="min-h-screen py-16 px-4 sm:px-6 lg:px-8 bg-[#0a0a0c] text-slate-200">
      <div className="max-w-7xl mx-auto">
        
        {/* Header - Sleeker Typography */}
        <div className="text-center mb-16">
          <span className="text-emerald-500 font-bold tracking-[0.3em] text-xs uppercase mb-4 block">Manufacturing Excellence</span>
          <h2 className="text-4xl md:text-6xl font-black mb-6 tracking-tight text-white leading-none">
            Apparel <span className="text-slate-500">Intelligence.</span>
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto text-lg leading-relaxed">
            Vertically integrated supply chain management from sustainable yarn spinning to global retail delivery.
          </p>
        </div>

        {/* Product Showcase - NEW SECTION */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-24">
          {products.map((product, idx) => (
            <div key={idx} className="group relative bg-[#141417] rounded-2xl overflow-hidden border border-white/5 hover:border-emerald-500/50 transition-all duration-500 shadow-2xl">
              <div className="h-64 overflow-hidden">
                <img 
                  src={product.img} 
                  alt={product.name} 
                  className="w-full h-full  group-hover:scale-110 transition-transform duration-700 opacity-80 group-hover:opacity-100"
                />
              </div>
              <div className="p-6">
                <div className="flex justify-between items-start mb-2">
                  <h4 className="text-xl font-bold text-white">{product.name}</h4>
                  <span className="text-[10px] bg-emerald-500/10 text-emerald-400 px-2 py-1 rounded uppercase tracking-wider font-bold">{product.category}</span>
                </div>
                <p className="text-sm text-slate-400 mb-4">{product.details}</p>
                <div className="flex items-center gap-2 text-xs text-slate-500 font-medium pt-4 border-t border-white/5 italic">
                  <Shirt size={14} /> {product.items}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Core Services - Refined Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-24">
          {[
            { icon: <Scissors className="text-emerald-500" />, title: "Precision Design", desc: "Digital pattern making and rapid 3D prototyping." },
            { icon: <Target className="text-emerald-500" />, title: "Quality Control", desc: "4-point inspection systems for zero-defect output." },
            { icon: <Box className="text-emerald-500" />, title: "Custom Packaging", desc: "Eco-friendly retail-ready branding and labeling." }
          ].map((service, i) => (
            <div key={i} className="p-8 bg-gradient-to-b from-[#1a1a1e] to-[#141417] rounded-3xl border border-white/5 hover:bg-[#1f1f23] transition-colors">
              <div className="mb-6 w-12 h-12 flex items-center justify-center bg-white/5 rounded-xl">{service.icon}</div>
              <h3 className="text-xl font-bold mb-3 text-white">{service.title}</h3>
              <p className="text-slate-400 text-sm leading-relaxed mb-6">{service.desc}</p>
              <div className="flex items-center gap-2 text-emerald-400 text-xs font-bold uppercase tracking-widest">
                <Zap size={14} /> 30-Day Lead Time
              </div>
            </div>
          ))}
        </div>

        {/* Manufacturing Steps - Horizontal Scrollable on Mobile */}
        <div className="bg-[#111114] p-10 rounded-[2.5rem] border border-white/5 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-500/5 blur-[100px] rounded-full"></div>
          <h3 className="text-2xl font-bold mb-10 text-white text-center">Integrated Factory Workflow</h3>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { emoji: "🧵", label: "Yarn Spinning", sub: "Sustainable Fibers" },
              { emoji: "🧶", label: "Knitting/Dyeing", sub: "Eco-Safe Dyes" },
              { emoji: "✂️", label: "Automated Cutting", sub: "Zero-Waste Tech" },
              { emoji: "🔨", label: "Final Finishing", sub: "Garment Wash" }
            ].map((step, i) => (
              <div key={i} className="text-center group">
                <div className="text-4xl mb-4 group-hover:scale-125 transition-transform duration-300 block">{step.emoji}</div>
                <p className="text-white font-bold text-sm mb-1">{step.label}</p>
                <p className="text-slate-500 text-xs">{step.sub}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Trust Badges */}
        <div className="mt-16 flex flex-wrap justify-center gap-8 opacity-40 grayscale hover:grayscale-0 transition-all">
           <div className="flex items-center gap-2 font-black text-xl italic"><ShieldCheck size={20}/> BSCI COMPLIANT</div>
           <div className="flex items-center gap-2 font-black text-xl italic"><Users size={20}/> OEKO-TEX</div>
           <div className="flex items-center gap-2 font-black text-xl italic"><Truck size={20}/> GRS CERTIFIED</div>
        </div>

      </div>
    </div>
  );
};

export default ApparelServices;